import { ICartCombo } from '@/store/ducks/combos/types';
import { ICartProduct } from '@/store/ducks/order/types';

export interface ComboGroups {
  [comboSeqId: number]: ICartProduct[];
}

export const separateProducts = (products: ICartProduct[]) => {
  const comboProducts = products.filter((p) => p.combo_seq_id);
  const regularProducts = products.filter((p) => !p.combo_seq_id);

  return { comboProducts, regularProducts };
};

export const groupComboProducts = (comboProducts: ICartProduct[]): ComboGroups => {
  return comboProducts.reduce((groups, product) => {
    const comboSeqId = product.combo_seq_id;
    if (!groups[comboSeqId]) {
      groups[comboSeqId] = [];
    }
    groups[comboSeqId]?.push(product);
    return groups;
  }, {} as ComboGroups);
};

export const getComboName = (combos: ICartCombo[], comboId: number, comboSeqId: string): string => {
  return combos?.find((c) => c.id === comboId)?.name || `Combo ${comboSeqId}`;
};

export const canShowAddMoreItems = (order: any): boolean => {
  return order.status === 1 && !order.is_paid;
};

export const shouldShowStatusSteps = (order: any, showSteps: boolean): boolean => {
  return showSteps || (order.status !== 1 && order.status !== 4);
};
